import CustomDropdownBorder from "../CustomDropdownBorder/CustomDropdownBorder.vue";
import Switcher from '@/components/Switcher/Switcher.vue'
import VueClipboard from 'vue-clipboard2'

export default {
    name: "TableMobileShared",
    components: {CustomDropdownBorder, Switcher, VueClipboard},
    data() {
        return {
            sortBy: [
                { id: 1, name: 'Created At' },
                { id: 2, name: 'Visits' },
                { id: 3, name: 'Downloads' }
            ],
            selectedSortedOption: { id: 1, name: 'Created At' },
            // list: [
            //     {
            //         id: 1,
            //         name: 'Test01',
            //         created_on: '03/03/2021',
            //         active: true,
            //         page_url: 'kdlsnlkddsafsaadaasdsasdadas',
            //         visits: 289,
            //         downloads: 150
            //     },
            //     {
            //         id: 2,
            //         name: 'Test02',
            //         created_on: '03/03/2021',
            //         active: true,
            //         page_url: 'kdlsnlkd',
            //         visits: 289,
            //         downloads: 150
            //     },
            //     {
            //         id: 3,
            //         name: 'Test03',
            //         created_on: '03/03/2021',
            //         active: true,
            //         page_url: 'kdlsnlkd',
            //         visits: 289,
            //         downloads: 150
            //     },
            // ]
        }
    },
    props: ['list'],
    methods: {
        changeActive() {

        },
        link(uri) {
            return process.env.VUE_APP_URL + `/${uri}`;
        }
    }
}